import React, {Component} from 'react';
import T from 'i18n-react';
// Composants
import AutoCompleteInput from '../../autoCompleteInput/AutoCompleteInput';
import MenuItem from 'material-ui/MenuItem';
import SelectField from "material-ui/SelectField";
import IconButton from 'material-ui/IconButton';
import FontIcon from 'material-ui/FontIcon';
import MaterialFormInput from "../../materialFormInput/MaterialFormInput";
import YearPicker from "../../yearPicker/YearPicker";
// Enum
import COLORS from '../../../enums/ColorEnum';
import LOCATIONS from '../../../enums/Location';
import MONTH from '../../../enums/Month';
// Style
import "../ReportingHeader.css";

const autoCompleteConfig = {
    input: {
        color: COLORS.BLACK,
        textFieldStyle: {
            color: COLORS.BLACK,
            textareaStyle: {
                color: COLORS.BLACK
            }
        },
        underlineShow: true,
        underlineStyle: {
            width: 'calc(100% + 24px)'
        }
    }
};

/**
 * Composant affichant les filtres pour la page d'historique des magasins
 */
class TableFilters extends Component {

    constructor(props) {
        super(props);

        //Options pour les pays
        this.allLocationList = (selectedValue) => Object.keys(LOCATIONS).sort((a, b) => (a > b) ? 1 : -1).map((value, index) => (
            <MenuItem style={{textTransform: 'capitalize'}} className="location" key={index} value={value}
                      checked={selectedValue && selectedValue === value} primaryText={value}/>
        ));
    }

    render() {
        return (
            <div className="filterContainer">
                {this.props.yearFilter &&
                    this.renderYearFilter()
                }
                {this.props.monthListFilter &&
                    this.renderMonthListFilter()
                }
                {this.props.hasOneLocation ? null :
                    <SelectField className='profileDropdown'
                                 value={this.props.location}
                                 hintText={T.translate('tableHeader.country')}
                                 onChange={(event, key, value) => this.props.handleFilterChange('location', value)}
                                 dropDownMenuProps={{
                                     anchorOrigin: {
                                         vertical: "bottom",
                                         horizontal: "left"
                                     },
                                 }}>
                        {this.allLocationList(this.props.location)}
                    </SelectField>
                }
                {this.renderClientMenu()}
                {this.renderBuMenu()}
                <MaterialFormInput
                    hintText={T.translate('filters.search', {'entity': T.translate(`filters.entities.${this.props.searchedEntity}`)})}
                    id="shopInput"
                    className="searchInput"
                    value={this.props.search ? this.props.search : ''}
                    onChange={(event, value) => this.props.handleFilterChange('search', value, true)}
                />
                <IconButton tooltip={T.translate('filters.resetFilters')} onClick={this.props.resetFilters}>
                    <FontIcon className="material-icons" color="inherit">close</FontIcon>
                </IconButton>
            </div>
        )
    }

    renderClientMenu() {
        // Si on a plusieurs clients on crée un menu drop down
        if (this.props.clientList && this.props.clientList.length > 1) {
            let clientDataSource = this.props.clientList;
            //Si un pays est sélectionné, on filtre la liste de clients
            if (this.props.location) {
                clientDataSource = clientDataSource.filter(client => client.location === this.props.location);
            }

            return (
                <div>
                    <AutoCompleteInput
                        name="client"
                        dataSource={clientDataSource.sort((a, b) => (a.name > b.name) ? 1 : -1)}
                        hintText={T.translate("tableHeader.client")}
                        selectItem={(value) => this.props.handleFilterChange('client', value)}
                        configs={autoCompleteConfig}
                        itemDisplayed={this.props.client}
                    />
                </div>
            );
        } else if (this.props.clientList) { // Sinon on affiche juste le nom du client
            const client = this.props.clientList[0];
            return (
                <div>
                    <label>{T.translate("tableHeader.client")} :</label>
                    <div className="tableHeader-value">{client.name}</div>
                </div>
            );
        }
    }

    renderBuMenu() {
        // Si on a plusieurs bu on crée un menu drop down
        if (this.props.buList && this.props.buList.length > 1) {
            let buDataSource = this.props.buList;
            //On filtre la liste en fonction des champs déjà pleins
            if (this.props.client) {
                buDataSource = buDataSource.filter(bu => bu.idClient === this.props.client.id);
            } else if (this.props.location) {
                buDataSource = buDataSource.filter(bu => bu.location === this.props.location);
            }

            return (
                <div>
                    <AutoCompleteInput
                        name="bu"
                        dataSource={buDataSource.sort((a, b) => (a.name > b.name) ? 1 : -1)}
                        hintText={T.translate("tableHeader.bu")}
                        selectItem={(value) => this.props.handleFilterChange('bu', value)}
                        configs={autoCompleteConfig}
                        itemDisplayed={this.props.bu}
                    />
                </div>
            );
        } else if (this.props.buList) { // Sinon on affiche juste le nom du client
            const bu = this.props.buList[0];
            return (
                <div>
                    <label>{T.translate("tableHeader.bu")} :</label>
                    <div className="tableHeader-value">{bu.name}</div>
                </div>
            );
        }
    }

    renderYearFilter() {
        return (
            <YearPicker
                name="year"
                label={T.translate("filters.yearPlaceHolder")}
                value={this.props.year}
                onChange={(value) => this.props.handleFilterChange('year', value)}
            >
            </YearPicker>
        )
    }

    renderMonthListFilter() {
        return (
            <SelectField
                className='profileDropdown'
                multiple={true}
                value={this.props.monthList}
                hintText={T.translate('month.placeholder')}
                onChange={(event, key, value) => this.props.handleFilterChange('monthList', value)}
                dropDownMenuProps={{
                    anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "left"
                    },
                }}>
                {
                    Object.keys(MONTH).map((value, index) => (
                        <MenuItem key={index}
                                  value={MONTH[value].value}
                                  checked={this.props.monthList && this.props.monthList.indexOf(MONTH[value].value) > -1}
                                  primaryText={T.translate("month." + MONTH[value].code)}/>
                    ))
                }
            </SelectField>
        )
    }
}

export default TableFilters


// WEBPACK FOOTER //
// ./src/components/tableComponent/filters/TableFilters.js